import { intentLibrary } from './intentLibrary';
import { chatApi } from '../services/api';

export const detectIntent = async (message, contextState = {}) => {
  try {
    // Call the secure backend endpoint using the correct API method
    const result = await chatApi.detectIntent(
      message,
      contextState,
      localStorage.getItem('chatSessionId')
    );
    
    // Map backend action/area to intentLibrary id
    let intentId = null;
    if (result.action === 'create' && result.area === 'issue') {
      intentId = 'raise_issue';
    } else if (result.action === 'analyze' && result.area === 'issue') {
      intentId = 'analyze_issues';
    } else if (result.action === 'view' && result.area === 'issue') {
      intentId = 'analyze_issues';
    } else if (result.action === 'edit' && result.area === 'issue') {
      intentId = 'edit_issue';
    } else if (result.action === 'update' && result.area === 'issue') {
      intentId = 'edit_issue';
    } else if (result.action === 'create' && result.area === 'risk') {
      intentId = 'create_risk';
    } else if (result.action === 'analyze' && result.area === 'risk') {
      intentId = 'analyze_risks';
    } else if (result.action === 'create' && result.area === 'incident') {
      intentId = 'report_incident';
    } else if (result.action === 'define' && result.area === 'control') {
      intentId = 'define_control';
    } else if (result.action === 'create' && result.area === 'control') {
      intentId = 'define_control';
    } else if (result.action === 'review' && result.area === 'compliance') {
      intentId = 'review_compliance';
    }
    // Add more mappings as needed

    const matchedIntent = intentLibrary.find(i => i.id === intentId);
    if (matchedIntent) {
      return {
        backendIntent: result,
        intent: matchedIntent,
        score: result.confidence,
        extracted: result.extracted,
        contextHint: contextState.lastIntent?.entityType || null
      };
    }

    return null;
  } catch (error) {
    console.error('Intent detection error:', error);
    return null;
  }
};
